<template>
  <function-upgrade></function-upgrade>
</template>

<script>
import FunctionUpgrade from '@/components/common/FunctionUpgrade'
export default {
  name: 'Upgrade',
  components: {
    FunctionUpgrade
  },
  data () {
    return {
      //
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style scoped>

</style>
